export default {
  methods: {
    mapLayerDesignatedroutesRubbertireliftmaintenanceAdd() {
      this.initPollDesignatedroutesRubbertireliftmaintenance();

      this.map.addSource("designatedroutes-rubbertireliftmaintenance-source", {
        type: "geojson",
        data: this.computedDesignatedroutesRubbertireliftmaintenanceGeoJson
      });

      this.map.addLayer({
        filter: [
          "any",
          ["in", "Standard", ["get", "department"]],
          ["in", "Maintenance", ["get", "department"]]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-fatfinger",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "Brown",
          "line-width": 20,
          "line-opacity": 0
        }
      });

      // Class 1
      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "1"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class1",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "black",
          "line-width": 3,
          "line-opacity": 1
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "1"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class1-halo",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "green",
          "line-width": 6,
          "line-opacity": 1
        }
      });

      // Class 2
      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "2"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class2",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "black",
          "line-width": 3,
          "line-opacity": 1
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "2"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class2-halo",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "blue",
          "line-width": 6,
          "line-opacity": 1
        }
      });

      // Class 3
      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "3"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class3",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "black",
          "line-width": 3,
          "line-opacity": 1
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "3"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-class3-halo",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "white",
          "line-width": 6,
          "line-opacity": 1
        }
      });

      this.map.addLayer({
        filter: [
          "all",
          ["==", ["get", "class"], "abc123"],
          [
            "any",
            ["in", "Standard", ["get", "department"]],
            ["in", "Maintenance", ["get", "department"]]
          ]
        ],
        id: "designatedroutes-rubbertireliftmaintenance-hover",
        type: "line",
        source: "designatedroutes-rubbertireliftmaintenance-source",
        paint: {
          "line-color": "Purple",
          "line-width": 12,
          "line-blur": 2
        }
      });

      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-hover",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class1-halo",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class1",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class2-halo",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class2",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class3-halo",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-class3",
        "marker-layer-lines"
      );
      this.map.moveLayer(
        "designatedroutes-rubbertireliftmaintenance-fatfinger",
        "marker-layer-lines"
      );
    },
    mapLayerDesignatedroutesRubbertireliftmaintenanceRemove() {
      this.cancelPollDesignatedroutesRubbertireliftmaintenance();
      this.map.removeLayer("designatedroutes-rubbertireliftmaintenance-hover");
      this.map.removeLayer("designatedroutes-rubbertireliftmaintenance-class1");
      this.map.removeLayer(
        "designatedroutes-rubbertireliftmaintenance-class1-halo"
      );
      this.map.removeLayer("designatedroutes-rubbertireliftmaintenance-class2");
      this.map.removeLayer(
        "designatedroutes-rubbertireliftmaintenance-class2-halo"
      );
      this.map.removeLayer("designatedroutes-rubbertireliftmaintenance-class3");
      this.map.removeLayer(
        "designatedroutes-rubbertireliftmaintenance-class3-halo"
      );
      this.map.removeLayer(
        "designatedroutes-rubbertireliftmaintenance-fatfinger"
      );
      this.map.removeSource(
        "designatedroutes-rubbertireliftmaintenance-source"
      );
    },
    initPollDesignatedroutesRubbertireliftmaintenance() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/designatedroutes/rubbertirestandard",
        dept: "designatedroutes",
        layer: "rubbertireliftmaintenance",
        token: this.computedAuthToken
      });
      this.pollDesignatedroutesRubbertireliftmaintenanceInterval = setInterval(
        () => {
          this.$store.dispatch("actionGetGeoJson", {
            url:
              "https://api2.alchemymapping.com/vail/whistler/designatedroutes/rubbertirestandard",
            dept: "designatedroutes",
            layer: "rubbertireliftmaintenance",
            token: this.computedAuthToken
          });
        },
        this.computedInterval
      );
    },
    cancelPollDesignatedroutesRubbertireliftmaintenance() {
      this.pollDesignatedroutesRubbertireliftmaintenanceInterval = clearInterval(
        this.pollDesignatedroutesRubbertireliftmaintenanceInterval
      );
    }
  },
  computed: {
    computedDesignatedroutesRubbertireliftmaintenanceGeoJson() {
      return this.$store.state.mapLayers.designatedroutes.layers
        .rubbertireliftmaintenance.geojson;
    },
    computedDesignatedroutesRubbertireliftmaintenanceMapVisibility() {
      return this.$store.state.mapLayers.designatedroutes.layers
        .rubbertireliftmaintenance.visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.designatedroutes.layers.rubbertireliftmaintenance.geojson": {
      handler() {
        if (this.computedDesignatedroutesRubbertireliftmaintenanceGeoJson) {
          this.mapLayerDesignatedroutesRubbertireliftmaintenanceRemove();
          this.mapLayerDesignatedroutesRubbertireliftmaintenanceAdd();
        }
      }
    },
    "$store.state.mapLayers.designatedroutes.layers.rubbertireliftmaintenance.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerDesignatedroutesRubbertireliftmaintenanceAdd();
      } else {
        this.mapLayerDesignatedroutesRubbertireliftmaintenanceRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollDesignatedroutesRubbertireliftmaintenance();
  }
};
